var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-markdown"},[_c('html',[_c('head'),_c('body',[_c('div',{staticClass:"intro"},[_vm._m(0),_c('p',[_c('embedded-autocomplete',{attrs:{"home-search":true,"show-search-button":true,"auto-focus":true}})],1)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{attrs:{"src":require("../../assets/img/monarch-logo-white-stacked.png"),"alt":""}})])
}]

export { render, staticRenderFns }